// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"9ca141b5","382":"0050004a","507":"0885b2cf","572":"9ca141b5","673":"f3e68e04"}[chunkId] + ".chunk.css";
};